import {Card, CardVariantType} from 'platform/components';
import {VStack} from 'platform/foundation';

import {ReactNode} from 'react';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

export interface SubSectionProps extends RequiredTestIdProps {
  title?: string;
  useCard?: boolean;
  children: ReactNode;
  isExpandable?: boolean;
  actions?: React.ComponentProps<typeof Card>['actions'];
  cardVariant?: CardVariantType;
}

/**
 * Section primitive - provides consistent Card wrapper for form sections
 *
 * @example
 * <Section title="Basic Information">
 *   <Field name="vin" />
 *   <Field name="make" />
 * </Section>
 */
export function SubSection(props: SubSectionProps) {
  const {
    title,
    children,
    isExpandable,
    actions,
    useCard = false,
    cardVariant,
    ...testIdProps
  } = props;

  return useCard ? (
    <Card
      variant={cardVariant ?? 'inlineGrey'}
      title={title}
      isExpandable={isExpandable}
      actions={actions}
      data-testid={suffixTestId('section', testIdProps)}
    >
      <VStack spacing={4}>{children}</VStack>
    </Card>
  ) : (
    children
  );
}
